<template>
  <div>
    <title-edit header="FAQ Category" />
    <line-hr />
    <br>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Category name* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.category_name" @update="updateCategory"/>
      </v-col>
    </div>
    <br>
    <line-hr />
    <command-button @delete-info="deleteFaqCategory" @save-info="saveFaqCategory" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
  import TitleEdit from "../../components/TitleHeader/TitleEdit";
  import LineHr from "../../components/Icon/line-hr";
  import SelectOption from "../../components/Input/selectOption";
  import InputTextField from "../../components/Input/InputTextField";
  import DeleteButton from "../../components/Button/DeleteButton";
  import PreviewButton from "../../components/Button/PreviewButton";
  import SaveButton from "../../components/Button/SaveButton";
  import {mapState} from "vuex";
  import Swal from 'sweetalert';
  import {permissionFaqCategory, role} from "../../util/Permission";
  import CommandButton from "../../components/Layout/CommandButton";

  export default {
    name: "FaqCategory.vue",
    components: {
      CommandButton,
      SaveButton,
      PreviewButton, DeleteButton, InputTextField, SelectOption, LineHr, TitleEdit},
    data(){
      return{
        optionCategory:[],
        permission : null,
      }
    },
    computed: {
      permissionFaqCategory,
      ...mapState({
        form: state => {
          return state.FaqCategory.form;
        }
      })
    },
    created() {
      this.permission = role;
      this.getFaqCategoryAll();
    },
    methods:{
      getFaqCategoryAll(){
        this.$store.dispatch("FaqCategory/getFaqCategoryAll").then(res=>{
          this.optionCategory = [
            { text: "Select", value: "" },
            ...res.map(type => ({
              value: type.category_id,
              text: type.category_name
            }))
          ];
        })
      },
      validateData(){
        if(!this.form.category_name){
          Swal('','Please Select Category','error');
          return false;
        }
        else{
          return true;
        }
      },
      saveClose(){
        if(this.validateData()){
          this.$store.dispatch("FaqCategory/saveFaqCategory",{
            id : this.form.category_id,
            data : this.form
          }).then(res=>{
            Swal(res.response_msg);
            if(res.response_code == 200){
              this.goToFaqCategory();
            }
          }).catch(()=>{
            Swal('','Cannot save Faq data','error');
          })
        }
      },
      saveFaqCategory(){
        if(this.validateData()){
          this.$store.dispatch("FaqCategory/saveFaqCategory",{
            id : this.form.category_id,
            data : this.form
          }).then(res=>{
            Swal(res.response_msg);
          }).catch(()=>{
            Swal('','Cannot save Faq data','error');
          })
        }
      },
      goToFaqCategory(){
        this.$router.push("/faq/faq-category");
      },
      deleteFaqCategory(){
        this.$store.dispatch("FaqCategory/deleteFaqCategory",this.form.category_id).then(res=>{
          Swal(res.response_msg);
          if(res.response_code == 200){
            this.goToFaqCategory();
          }
        }).catch(()=>{
          Swal('','Cannot delete Faq data','error');
        })
      },
      updateCategory(val){
        this.form.category_name = val;
      },
    }
  }
</script>

<style scoped>

</style>
